import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as policyArea from '../policy-area'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: policyArea.RESOURCE.payload.dimension.partialId,
      partialId: policyArea.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Position of this area when areas are listed, lowest first.',
    isOptional: true,
    name: 'Sort Order',
    partialId: PartialId.Standard.create('sort_order'),
    type: core.common.value.types.Intrinsic.Integer,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
